import SpinnerIcon from "assets/images/icons/spinner.svg?react";
import { cn } from "design-system/utils";

const loaderSizes = {
  lg: "size-20",
  md: "size-16",
  sm: "size-12",
  xs: "",
};

type LoaderProps = {
  size?: keyof typeof loaderSizes;
  className?: string;
};

export default function Loader({ size = "lg", className }: LoaderProps) {
  return (
    <SpinnerIcon
      className={cn(
        "my-2 animate-spin stroke-primary-50",
        loaderSizes[size],
        className,
      )}
    />
  );
}

export function LoaderWrapper({ size = "lg" }: LoaderProps) {
  return (
    <div className="flex w-full items-center justify-center">
      <Loader size={size} />
    </div>
  );
}

export function Spinner() {
  return <SpinnerIcon className="animate-spin stroke-gray" />;
}
